import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withTranslate } from 'react-redux-multilingual'
import { withStyles } from '@material-ui/core/styles'
import BookingInfoBasic from './BookingInfoBasic'
import BookingInfoQuestion from './BookingInfoQuestion'
import PhotoUploadStep from './booking-info/PhotoUploadStep'
import TermsAndConditions from './TermsAndConditions'
import Loading from './Loading'
import Success from './Success'
import Error from './Error'
import ErrorMessage from './ErrorMessage'
import StepHeader from './booking-info/StepHeader'
import StepNavFooter from './booking-info/StepNavFooter'
import Genders from '../modules/genders'
import Country from '../modules/countries'
import Question from '../modules/questions'
import Reservation from '../modules/reservation'
import {
  findScreenSlug,
  validateGuestInfo,
  validateQuestions,
  blankCheckin,
  applyDevDefaults,
  stripHiddenFields
} from '../helpers/checkin-validators'

const MAX_STEPS = 5

class BookingInfoRoomStep extends React.Component {
  state = {
    checkin_fields_behaviour: [],
    checkin_additional_field: [],
    loading: true,
    activeStep: 0,
    bookingInfo: {
      id: -1,
      check_in_date: null,
      check_out_date: null,
      name: '',
      surname: '',
      email: '',
      country_id: -1,
      total: 0,
      taxes: 0,
      accomodation_discount: 0,
      discount: 0,
      deposit: 0,
      coupon_discount_amount: null,
      rooms: [],
      edp: '',
      has_debit: false,
      debit: 0
    },
    checkin: blankCheckin(this.props.roomId),
    propertyInfo: {
      property_name: '',
      checkin_terms: ''
    },
    validEmailBasicInfo: false,
    documentValidationBasicInfo: false,
    validDateBirthBasicInfo: false,
    valid: true,
    genders: [],
    countries: [],
    questions1: [],
    questions2: [],
    terms_accepted: false,
    open_terms: false,
    save_success: false,
    save_message: '',
    dateIn: new Date(),
    dateOut: new Date(),
    selfImageUpload: false,
    documentImageUpload: false,
    error_message: null
  }

  constructor(props) {
    super(props)
    this.validate = this.validate.bind(this)
    this.saveForm = this.saveForm.bind(this)
    this.resetSteps = this.resetSteps.bind(this)
  }

  async componentDidMount() {
    const locale = this.props.locale

    const [genders, countries, questions, checkin] = await Promise.all([
      Genders.getGenders(locale),
      Country.getCountries(locale),
      Question.getQuestions(locale),
      Reservation.getCheckin(locale)
    ])

    if (genders) this.setState({ genders: genders.result.genders })
    if (countries) this.setState({ countries: countries.result.countries })
    if (questions) {
      const { questions1, questions2 } = splitQuestions(questions.result.questions)
      this.setState({ questions1, questions2 })
    }
    if (checkin) {
      const next = buildCheckinState(checkin.result, this.props.roomId, this.props.currentGuest)
      this.setState(next)
    }

    this.setState({ loading: false })
  }

  setCheckinField = (name, value) => {
    this.setState((prevState) => ({
      checkin: { ...prevState.checkin, [name]: value }
    }))
  }

  handleChangeTF = (name) => (event) => {
    // React 16 ainda recicla synthetic events; o setState com updater roda
    // assíncrono, então precisamos capturar event.target.value agora.
    const value = event.target.value

    if (name === 'email') {
      this.setState({ validEmailBasicInfo: !Isemail.validate(value) })
    }
    if (name === 'document') {
      this.setState({ documentValidationBasicInfo: value === '' })
    }
    if (name === 'birth_date') {
      this.setState({ validDateBirthBasicInfo: value === '' })
    }

    this.setState((prevState) => ({
      checkin: { ...prevState.checkin, [name]: value }
    }))
  }

  handleChange = (event) => {
    const { name, value } = event.target
    this.setState((prevState) => ({
      checkin: { ...prevState.checkin, [name]: value }
    }))
  }

  handleChangeSw = (name) => (event) => {
    const checked = event.target.checked
    this.setState((prevState) => ({
      checkin: { ...prevState.checkin, [name]: checked }
    }))
  }

  handleNext = () => {
    const isValid = this.validate()
    this.setState((prevState) => ({
      valid: isValid,
      activeStep: isValid ? prevState.activeStep + 1 : prevState.activeStep
    }))
  }

  handleBack = () => {
    this.setState((prevState) => ({ activeStep: prevState.activeStep - 1 }))
  }

  seeTerms = () => (event) => {
    const checked = event.target.checked
    this.setState({
      terms_accepted: checked,
      open_terms: checked
    })
  }

  closeTerms = () => {
    this.setState({ open_terms: false })
  }

  checkSelfImageUpload = () => {
    this.setState({ selfImageUpload: true })
  }

  checkDocumentImageUpload = () => {
    this.setState({ documentImageUpload: true })
  }

  resetSteps = () => {
    this.props.updateCurrentGuest(this.props.currentGuest + 1)
    this.setState({
      terms_accepted: false,
      save_success: false,
      save_message: '',
      activeStep: 0,
      checkin: blankCheckin(this.props.roomId)
    })
  }

  validate() {
    const screen = findScreenSlug(this.state.activeStep)
    const fields = this.state.checkin_fields_behaviour
    const checkin = this.state.checkin

    switch (screen) {
      case 'guest-info': {
        if (isRequired(fields, 'document') && !checkin.document) {
          this.setState({ documentValidationBasicInfo: true })
        }
        if (isRequired(fields, 'email') && checkin.email === '') {
          this.setState({ validEmailBasicInfo: true })
        }
        if (isRequired(fields, 'date_of_birth') && !checkin.birth_date) {
          this.setState({ validDateBirthBasicInfo: true })
        }
        return validateGuestInfo(fields, checkin)
      }
      case 'guest-photo': {
        this.setState({ error_message: null })
        if (isRequired(fields, 'upload_photo') && !this.state.selfImageUpload) {
          this.setState({ error_message: this.props.translate('uploadPhotoRequired') })
          return false
        }
        return true
      }
      case 'guest-document-photo': {
        this.setState({ error_message: null })
        if (isRequired(fields, 'upload_document') && !this.state.documentImageUpload) {
          this.setState({ error_message: this.props.translate('uploadDocumentRequired') })
          return false
        }
        return true
      }
      case 'guest-questions': {
        const ok = validateQuestions(
          fields,
          checkin,
          this.state.terms_accepted,
          this.state.checkin_additional_field
        )
        if (ok) this.saveForm()
        return ok
      }
      default:
        return true
    }
  }

  saveForm = () => {
    this.setState({ loading: true })

    const dateFormat = this.props.translate('dateformat')
    const payload = stripHiddenFields(this.state.checkin, this.state.checkin_fields_behaviour)
    payload.birth_date = formatBirthDateForApi(payload.birth_date, dateFormat)
    payload.country_entry_date = formatIsoDateForApi(payload.country_entry_date, dateFormat)

    Reservation.saveCheckin(payload).then((response) => {
      if (!response) {
        this.setState({ save_success: false, loading: false })
        return
      }
      const next = { save_success: response.status, loading: false }
      if (response.result && response.result.error_message) {
        next.save_message = response.result.error_message
      }
      this.setState(next)
    })
  }

  render() {
    const { classes } = this.props
    const { activeStep, loading } = this.state

    return (
      <div className={classes.root}>
        <TermsAndConditions
          open={this.state.open_terms}
          content={this.state.propertyInfo.checkin_terms}
          handleClose={this.closeTerms}
        />

        <StepHeader
          hidden={loading}
          reservationId={this.state.bookingInfo.id}
          locale={this.props.locale}
          dateIn={this.state.dateIn}
          dateOut={this.state.dateOut}
        />

        {loading ? (
          <Loading visible={loading} />
        ) : (
          <>
            {this.state.error_message !== null && (
              <ErrorMessage message={this.state.error_message} />
            )}
            {this.getStepContent(activeStep)}
          </>
        )}

        {findScreenSlug(activeStep) !== 'success' && (
          <StepNavFooter
            activeStep={activeStep}
            maxSteps={MAX_STEPS}
            loading={loading}
            onBack={this.handleBack}
            onNext={this.handleNext}
          />
        )}
      </div>
    )
  }

  getStepContent(step) {
    const screen = findScreenSlug(step)

    switch (screen) {
      case 'guest-info':
        return (
          <BookingInfoBasic
            valid={this.state.valid}
            checkin={this.state.checkin}
            bookingInfo={this.state.bookingInfo}
            genders={this.state.genders}
            countries={this.state.countries}
            handleChangeTF={this.handleChangeTF}
            handleChange={this.handleChange}
            setCheckinField={this.setCheckinField}
            checkinFieldsBehaviour={this.state.checkin_fields_behaviour}
            validEmail={this.state.validEmailBasicInfo}
            validDocument={this.state.documentValidationBasicInfo}
            validDateBirth={this.state.validDateBirthBasicInfo}
          />
        )
      case 'guest-photo':
        return (
          <PhotoUploadStep
            key="self"
            type="self"
            setCheckinField={this.setCheckinField}
            onUploaded={this.checkSelfImageUpload}
          />
        )
      case 'guest-document-photo':
        return (
          <PhotoUploadStep
            key="document"
            type="document"
            setCheckinField={this.setCheckinField}
            onUploaded={this.checkDocumentImageUpload}
          />
        )
      case 'guest-questions':
        return (
          <BookingInfoQuestion
            valid={this.state.valid}
            terms_accepted={this.state.terms_accepted}
            checkin={this.state.checkin}
            questions1={this.state.questions1}
            questions2={this.state.questions2}
            handleChangeTF={this.handleChangeTF}
            handleChange={this.handleChange}
            setCheckinField={this.setCheckinField}
            checkinAdditionalField={this.state.checkin_additional_field}
            handleChangeSw={this.handleChangeSw}
            seeTerms={this.seeTerms}
            saveForm={this.saveForm}
            checkinFieldsBehaviour={this.state.checkin_fields_behaviour}
            propertyName={this.state.propertyInfo.property_name}
          />
        )
      case 'success':
        return this.state.save_success ? (
          <Success
            resetSteps={this.resetSteps}
            bookingInfo={this.state.bookingInfo}
            propertyInfo={this.state.propertyInfo}
            additionalGuests={this.props.currentGuest < this.props.totalGuests}
            propertyName={this.state.propertyInfo.property_name}
          />
        ) : (
          <Error message={this.state.save_message} />
        )
      default:
        return <div />
    }
  }
}

const Isemail = require('isemail')

function isRequired(fields, fieldName) {
  const entry = fields.find((e) => e.field === fieldName)
  return entry ? Boolean(entry.required) : false
}

function splitQuestions(questions) {
  const q1 = []
  const q2 = []
  questions.forEach((item) => {
    if (!item.hasOwnProperty('question')) return
    if (item.question === 'trip_motivation') q1.push(...item.options)
    if (item.question === 'property_choose_motivation') q2.push(...item.options)
  })
  return { questions1: q1, questions2: q2 }
}

function parseCheckinDate(dateStr) {
  const [year, month, day] = dateStr.split('-').map((n) => parseInt(n, 10))
  return new Date(Date.UTC(year, month - 1, day + 1, 0, 0, 0))
}

function normalizeFieldsBehaviour(fields) {
  return fields.map((f) => ({
    ...f,
    visible: parseInt(f.visible) === 1,
    required: parseInt(f.required) === 1
  }))
}

// O segundo hóspede (currentGuest > 1) começa com nome/sobrenome/email/data
// em branco; os demais campos são sempre resetados, independente do hóspede.
function buildCheckinPayload(rawBookingInfo, roomId, currentGuest) {
  const isAdditionalGuest = currentGuest > 1
  // Nacionalidade vem da reserva (`country_id`) — todos os hóspedes começam
  // marcados como compatriotas do titular. Editável caso não seja o caso.
  // País do endereço NÃO é pré-preenchido — endereço é informação por hóspede.
  const reservationNationality =
    rawBookingInfo.country_id > 0 ? String(rawBookingInfo.country_id) : '-1'
  return {
    ...rawBookingInfo,
    roomId,
    name: isAdditionalGuest ? '' : rawBookingInfo.name,
    surname: isAdditionalGuest ? '' : rawBookingInfo.surname,
    birth_date: isAdditionalGuest ? null : rawBookingInfo.birth_date,
    email: isAdditionalGuest ? '' : rawBookingInfo.email,
    phone: '',
    gender: '-1',
    nationality: reservationNationality,
    country: '-1',
    state: '-1',
    city: '-1',
    address: '',
    number: '',
    complement: '',
    neighborhood: '',
    postal_code: '',
    q1_origin: '',
    q2_destination: '',
    q3_trip_motivation: '',
    q4_property_choose_motivation: '',
    q5_information: '',
    country_entry_date: '',
    transport_method: ''
  }
}

function buildCheckinState(result, roomId, currentGuest) {
  return {
    bookingInfo: result.bookingInfo,
    checkin: applyDevDefaults(buildCheckinPayload(result.bookingInfo, roomId, currentGuest)),
    propertyInfo: result.propertyInfo,
    checkin_fields_behaviour: normalizeFieldsBehaviour(result.propertyInfo.checkin_fields_behaviour),
    checkin_additional_field: result.propertyInfo.checkin_additional_field,
    dateIn: parseCheckinDate(result.bookingInfo.check_in_date),
    dateOut: parseCheckinDate(result.bookingInfo.check_out_date)
  }
}

function formatBirthDateForApi(dateString, dateFormat) {
  if (dateString === undefined || dateString === null) return '0000-00-00'
  const parts = dateString.split('/')
  return dateFormat === 'dd/MM/yyyy'
    ? new Date(parts[2], parts[1] - 1, parts[0])
    : new Date(parts[2], parts[0] - 1, parts[1])
}

// Converte dd/MM/yyyy (ou MM/dd/yyyy, conforme locale) para YYYY-MM-DD.
// Vazio/inválido vira string vazia — o backend trata como NULL.
function formatIsoDateForApi(dateString, dateFormat) {
  if (!dateString) return ''
  const parts = dateString.split('/')
  if (parts.length !== 3 || parts.some((p) => !p.trim())) return ''
  const [day, month, year] = dateFormat === 'dd/MM/yyyy'
    ? [parts[0], parts[1], parts[2]]
    : [parts[1], parts[0], parts[2]]
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
}

const styles = (theme) => ({
  root: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(550 + theme.spacing(2) * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }
})

BookingInfoRoomStep.propTypes = {
  classes: PropTypes.object.isRequired,
  translations: PropTypes.object
}

function mapPropsToState(state) {
  const { Intl } = state
  return { ...Intl, key: Intl.locale }
}

export default compose(
  withStyles(styles),
  connect(mapPropsToState)
)(withTranslate(BookingInfoRoomStep))
